export default "__VITE_ASSET__e8301b92__"